import React from 'react';

import {
  RefinementAccordion,
  RefinementsContainer,
  StyleSelectAccordion,
  DurationSelectAccordion,
  TeachersSelectAccordion,
  LevelSelectAccordion,
  FocusSelectAccordion,
} from '../FinderPage';

export const MobileFilters: React.FC<{ hidden?: boolean }> = ({ hidden = false }) => {
  return (
    <RefinementsContainer hidden={hidden}>
      <RefinementAccordion.Group>
        <StyleSelectAccordion />
        <DurationSelectAccordion />
        <TeachersSelectAccordion />
        <LevelSelectAccordion />
        <FocusSelectAccordion />
      </RefinementAccordion.Group>
    </RefinementsContainer>
  );
};
